import React, { useState,useEffect } from 'react';
import { Container, Grid, Collapse, useMediaQuery, useTheme, Typography, Divider, Accordion, AccordionSummary, AccordionDetails, Box, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// @ts-ignore 
import iconDollar from '../../../assets/icons/iconDollar.svg';
import { TRIPDIRECTION , INSURANCEPLANCODE, INSURANCESTR, BookingFrom, PASSENGERTYPE, parseAmount} from '../../../utils/constant';
import { calculateTotalForPassenger } from '../../../utils/util';
import { useTranslation, Trans } from 'react-i18next';
import WhyBookWithUs from './WhyBookWithUs';
import { useUplift } from '../../Uplift/upliftCallback';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
// @ts-ignore
import InfoIcon from '../../../assets/icons/Icon-info-circle.svg';
import BookingWarningIcon from '../../../assets/icons/Booking_warningMsg.svg';

interface PriceSummaryComponentProps {
  itineraryFare: any; 
  insuranceTotal?: any;
  insuranceBreakdown?: any;
  giftCardBreakdown?:any;
  priceSummary?:any;
  componentCalledFrom?: string;
  isBookingPage?: boolean;
  mergedPaxFares: any;
  segmentData?: any
}


const PriceSummaryComponent: React.FC<PriceSummaryComponentProps> = ({ itineraryFare, insuranceTotal, insuranceBreakdown,giftCardBreakdown, priceSummary,componentCalledFrom, isBookingPage, mergedPaxFares, segmentData }) => {
  // console.log("segmentData in price summry", segmentData, componentCalledFrom)
  const { t, i18n } = useTranslation();
  const returnTaxes = (passengerFare: any) => {
      const { bookingFee, ticketingFee, passengerDetails, taxes, fareBreakDown} = passengerFare;
      const bFee  = bookingFee?.amount || fareBreakDown?.bookingFee?.amount || 0;
      const tFee  = ticketingFee?.amount || fareBreakDown?.ticketingFee?.amount || 0;
      const taxesAndFees = passengerFare.totalTaxes.amount + bFee + tFee;
      return taxesAndFees;
  }

  const isValidArray = (arr: any) => Array.isArray(arr) ? arr : [];
  const [expanded, setExpanded] = React.useState<string | false>('panel1');

  const [allSegmentCarrier, setAllSegmentCarrier] = useState([]);
  const [displayAirlineWarning, setDisplayAirlineWarning] = useState(false);

  // const giftCardTotal = (giftCardBreakdown ?? []).reduce((acc: number, giftCard: any) => acc + giftCard.charge, 0);
  const giftCardTotal = isValidArray(giftCardBreakdown).reduce((acc: number, giftCard: any) => acc + giftCard.charge, 0);

  const displayCurrency = '$';
  
  const language = i18n.language;
  const UPLIFT_CONFIG = process.env.UPLIFT_CONFIG || {};
    const { UPLIFT_LOGO } = UPLIFT_CONFIG as { [key: string]: string };

  // let totalFlightPrice = itineraryFare?.paxFares?.reduce((acc: number, current: any) => {
  //   return acc + calculateTotalForPassenger(current);
  // }, 0);

  let totalFlightPrice = isValidArray(itineraryFare?.paxFares).reduce((acc: number, current: any) => acc + calculateTotalForPassenger(current), 0);


  const itineryTotalFlightPrice = totalFlightPrice;
  if(giftCardTotal > 0){
    totalFlightPrice = Number(totalFlightPrice) - Number(giftCardTotal);
  }
  
  let finalTotalPrice = 0;
  if(insuranceTotal && Number(insuranceTotal) > 0){
    finalTotalPrice = Number(totalFlightPrice) + Number(insuranceTotal);
  }

  
  const priceSummaryData = {
    itineryTotal: itineryTotalFlightPrice,
    giftCardTotal:giftCardTotal,
    finalAmount:totalFlightPrice
  }

  const processInsurance = (
    insuranceBreakdown: Record<string, any>,
    displayCurrency: string,
    parseAmount: (amount: number) => string
  ) => {
    if (!insuranceBreakdown) return null;
  
    return Object.keys(insuranceBreakdown)
      .filter((val) => val !== INSURANCEPLANCODE.DECLINED)
      .map((val) => {
        const planDetails = insuranceBreakdown[val];
  
        const paxSummary: Record<string, { count: number; amount: number }> =
  Array.isArray(planDetails)
    ? planDetails.reduce(
        (acc, pax) => {
          if (!acc[pax.paxType]) {
            acc[pax.paxType] = { count: 1, amount: Number(pax.amount) };
          } else {
            acc[pax.paxType].count += 1;
            acc[pax.paxType].amount += Number(pax.amount);
          }
          return acc;
        },
        {} as Record<string, { count: number; amount: number }>
      )
    : {
        [planDetails.paxType]: {
          count: 1,
          amount: Number(planDetails.amount),
        },
      };

        console.log(paxSummary)
        const planTotalAmount = Object.values(paxSummary).reduce((sum, pax) => sum + pax.amount, 0);
  
        return (
          <Box className="booking_priceBody" key={val}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="h4" className="booking_priceBodyTitle">
                  {planDetails?.[0]?.planname}
                </Typography>
                {Object.keys(paxSummary).map((paxType) => (
                  <Typography key={paxType} variant="h4" className="booking_priceBodysubTitle">
                    {paxSummary[paxType].count} {t(paxType)} X {displayCurrency}
                    {parseAmount(paxSummary[paxType].amount / paxSummary[paxType].count)}
                  </Typography>
                ))}
              </Grid>
              <Grid item xs={6} style={{ textAlign: 'right' }}>
                <Typography variant="h4" className="booking_priceBodyTitle">
                  {displayCurrency}
                  {parseAmount(planTotalAmount)}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        );
      });
  };
  
  useEffect(() => {
    if(componentCalledFrom == 'confirmation' && allSegmentCarrier.length > 0){
      const warningCarriers = ['AF', 'KL'];
      const hasWarningCarrier = allSegmentCarrier.some(carrier => warningCarriers.includes(carrier));
      console.log("hasWarningCarrier", hasWarningCarrier, allSegmentCarrier, componentCalledFrom)
      setDisplayAirlineWarning(hasWarningCarrier);
    }
 }, [allSegmentCarrier]);
// console.log("displayAirlineWarning in pricesummer",displayAirlineWarning,allSegmentCarrier)
  
  useEffect(() => {
    if (segmentData && componentCalledFrom === 'confirmation') {
      const allCarriers: any = [];
      segmentData.forEach(segmentObj => {
        const segment = Object.values(segmentObj)[0] as { flights: any[] };
        if (segment && Array.isArray(segment.flights)) {
          segment.flights.forEach(flight => {
            if (flight.carrier) {
              allCarriers.push(flight.carrier);
            }
          });
        }
      });
      setAllSegmentCarrier(allCarriers);
    }
  }, [segmentData]);

  const handleFlightPriceAcc =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };


  useEffect(() => {
    if(componentCalledFrom!='confirmation'){
      priceSummary(priceSummaryData);
    }
  }, [giftCardTotal]);

 const [showPriceSummary, setShowPriceSummary] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleTogglePriceSummary = () => {
    if (isMobile) {
      setShowPriceSummary(prev => !prev);
    }
  };

  const { cardInfo, disable, reasonCode, tokenReady, paymentOption, upliftCallback, setPaymentOption } = useUplift();
  return (
    <div className='BookingPriceSummary_Wrapper'>
      <Box className='Booking_PriceSummary'>
        <Box className='Booking_PriceHeader Booking_PriceHeaderMb' onClick={isMobile ? handleTogglePriceSummary : undefined}>
       <Box display={'flex'}>
          <img src={iconDollar} className='Icon_flight' />
          <Typography variant="h6" className='Booking_PriceTitle'>
            {t('Price Summary')}
          </Typography>
        </Box>
        {isMobile && ( showPriceSummary ? <KeyboardArrowUp /> : <KeyboardArrowDown /> )}
       </Box>
        {/* Display all passenger fares sequentially */}
        <Collapse in={isMobile ? showPriceSummary : true}>
        <React.Fragment>
          <Accordion  expanded={expanded === 'panel1'} onChange={handleFlightPriceAcc('panel1')}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={"panel1-content"}
              id={"panel1-header"}
            >
              <Box className="Booking_FlightPrce">
              <Box>
                <Typography variant="h4" className='booking_AccoHeader'>{t('Flight Price')}</Typography>
              </Box>
              <Box>
                <Typography variant="h4" className='booking_AccoCurrency'>
                {displayCurrency}{itineryTotalFlightPrice.toFixed(2)}
                </Typography>
              </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
            {mergedPaxFares?.map((passengerFare: any, index: number) => {
                let baseAmount = passengerFare?.sellingBaseAmount?.amount 
                    ? passengerFare.sellingBaseAmount.amount 
                    : passengerFare?.fareBreakDown?.sellingBaseAmount?.amount 
                    ? passengerFare?.fareBreakDown?.sellingBaseAmount?.amount 
                    : 0;

                let baseCurrency = passengerFare?.sellingBaseAmount?.currency 
                    ? passengerFare.sellingBaseAmount.currency 
                    : passengerFare?.fareBreakDown?.sellingBaseAmount?.currency;

                const { passengerDetails, totalTaxes } = passengerFare;
                const taxes = returnTaxes(passengerFare);

                return (
                    <>
                        <Box className="booking_priceBody">
                          <Box>
                            <Typography variant="h4" className="booking_AccoCurrency">
                              {t('Total for')} {passengerDetails.quantity} {t(passengerDetails.type)} 
                            </Typography>
                            {/* <Typography variant="body2" className="booking_priceBodysubTitle">
                                        {passengerDetails.quantity} {t(passengerDetails.type)} X{' '}
                                        {displayCurrency}
                                        {baseAmount && baseAmount !== 0 ? baseAmount.toFixed(2) : '0.00'}{' '}
                                    </Typography> */}
                          </Box>
                          <Box>
                            <Typography variant="h4" textAlign="right" className="booking_AccoCurrency">
                              {displayCurrency}
                              {((baseAmount * passengerDetails.quantity)+((taxes * passengerDetails.quantity))).toFixed(2)}
                            </Typography>
                          </Box>
                        </Box>
                        <Box className="booking_priceBody">
                            <Box>
                                <Typography variant="h4" className="booking_priceBodyTitle">
                                    {t('Base price')}
                                </Typography>
                                {/* <Typography variant="body2" className="booking_priceBodysubTitle">
                                    {passengerDetails.quantity} {t(passengerDetails.type)} X{' '}
                                    {displayCurrency}
                                    {baseAmount && baseAmount !== 0 ? baseAmount.toFixed(2) : '0.00'}{' '}
                                </Typography> */}
                            </Box>
                            <Box>
                                <Typography variant="h4" textAlign="right" className="booking_priceBodyTitle">
                                    {displayCurrency}
                                    {(baseAmount * passengerDetails.quantity).toFixed(2)}
                                </Typography>
                            </Box>
                        </Box>
                        <Box className="booking_priceBody">
                            <Box>
                                <Typography variant="h4" className="booking_priceBodyTitle">
                                    {t('Taxes and fees')}
                                </Typography>
                                {/* <Typography variant="body2" className="booking_priceBodysubTitle">
                                    {passengerDetails.quantity} {t(passengerDetails.type)} X{' '}
                                    {displayCurrency}
                                    {taxes.toFixed(2)}{' '}
                                </Typography> */}
                            </Box>
                            <Typography variant="h4" className="booking_priceBodyTitle">
                                {displayCurrency}
                                {(taxes * passengerDetails.quantity).toFixed(2)}
                            </Typography>
                        </Box>
                    </>
                );
            })}
          </AccordionDetails>
          </Accordion>
          {(insuranceTotal && parseFloat(insuranceTotal) > 0) ? (
              <Accordion>
                <AccordionSummary
                   expandIcon={<ExpandMoreIcon />}
                   aria-controls={"panel1-content"}
                   id={"panel1-header"}
                   className='travelInsuranceHeader'
                >
                  <Grid item xs={6}>
                    <Typography variant="h4" className='booking_AccoHeader'>{t('Travel Insurance')}</Typography>
                  </Grid>
                  <Grid item xs={6} style={{ textAlign: 'right' }}>
                    <Typography variant="h4" className='booking_AccoCurrency'>
                    {displayCurrency}{parseAmount(insuranceTotal)}
                    </Typography>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                {/* <Typography variant="body1" className='booking_AccoCurrency'> */}
                <Box>
                <Box>{processInsurance(insuranceBreakdown, displayCurrency, parseAmount)}</Box>
                  {/* {insuranceBreakdown} */}
                  {/* </Typography> */}
                </Box>
                </AccordionDetails>
              </Accordion>
            ): (
              (insuranceTotal && parseFloat(insuranceTotal) > 0) ? 
              <Box className="Booking_PriceHeader">
                  <Grid item xs={6}>
                  <Typography variant="body1" className='booking_AccoHeader'>{t('Travel Insurance')}</Typography>
                </Grid>
                <Grid item xs={6} style={{ textAlign: 'right' }}>
                  <Typography variant="h4" className='booking_AccoCurrency'>
                  {displayCurrency}{parseAmount(insuranceTotal)}
                  </Typography>
                </Grid>
              </Box>
              :""
            )
          }

       
          {/* <Box className="Booking_priceTotal">
            <Grid item xs={6}>
              <Typography variant="body1" className='booking_AccoHeader'>Gift Card</Typography>
            </Grid>
          </Box>
          <Box>
                <Typography variant="body1" className='booking_AccoCurrency'>
                {giftCardTotal > 0 ? ` - ${giftCardTotal} CAD` : '0.00 CAD'}
                </Typography>
          </Box> */}
         {giftCardTotal > 0 ? (
            <Box className="Booking_priceFooter Booking_GiftCardFooter"  >
            <Box className="Booking_priceTotal">
                  <Box>
                    <Typography variant="h4" className='Booking_priceTotal'>{t('Gift Card')}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h4" className='booking_AccoCurrency'>
                    {displayCurrency}{giftCardTotal.toFixed(2)}
                    </Typography>
                  </Box>
              </Box>
             </Box>
         ):''} 
        

        </React.Fragment>
        
        {/* Display total price */}
        <Box className="Booking_priceFooter">
          <Box className="Booking_priceTotal">
            <Typography variant="h6" className='Booking_priceTotal'>{t('Total price')}</Typography>
            <Typography variant="h6" className='Booking_FlightPrice'>
            {(insuranceTotal && Number(insuranceTotal) > 0) ?
             'CA $'+ `${finalTotalPrice.toFixed(2)}` :'CA $'+ totalFlightPrice.toFixed(2)}
            </Typography>
          </Box>
          {/* <Box className="booking_FullPriceLink">
            <Typography variant="body2" className="booking_FullLink">
              Full price breakdown
            </Typography>
          </Box> */}
        </Box>
        <Box className= "booking_footer_warning">
            {displayAirlineWarning ?
                <Typography variant="h4" className='Booking_warningMsg'><img src={BookingWarningIcon} alt="Icon Airline Warning" />
                  {/* <span>
                    <Trans
                      i18nKey="airline_warning"
                      components={{
                        a: <a href="javascript:;" className="warningLinkclass" />
                      }}
                    />
                  </span> */}
                  {t('airline_warning')}
                </Typography>
                : null}
        </Box>
        </Collapse>
        
      </Box>


      {((!disable) && isBookingPage) ? (
        <Box
          className={`Booking_payTitle payUpliftTitle ${language === "fr" ? "payUpliftTitleFr" : ""
            }`}
          sx={{
            padding: "16px",
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            borderRadius: "8px",
            marginTop:"-20px",
            marginBottom: "2%",
            boxShadow: "0 2px 4px rgba(var(--main-primary-Black-rgb), 0.1);",
          }}
        >
          <Typography
            variant="h4"
            sx={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            {t("Pay Monthly")}
            {totalFlightPrice > 0 && (
              <>
                <span
                  data-up-price-value={parseAmount(totalFlightPrice * 100)}
                  data-up-price-type="total"
                  data-up-comparison-type=""
                  data-up-price-model="total"
                  data-up-taxes-included="true"
                >{t('from')} </span>
                <Button
                  className="displayFlex"
                  data-up-price-value={parseAmount(totalFlightPrice * 100)}
                  data-up-price-type="total"
                  data-up-comparison-type=""
                  data-up-price-model="total"
                  data-up-taxes-included="true"
                  sx={{
                    fontWeight: "bold",
                    color: "#000",
                    display: "flex",
                    alignItems: "center",
                    textTransform: "none",
                    paddingLeft: "0",
                    
                  }}
                >
                  <span>
                    <span className="up-from-currency">$</span>
                    <span className="mb-1" data-up-from-currency-unit-major=""></span>
                    /{t("mo")}
                  </span>
                  <img src={InfoIcon} className='Tb_upliftBookingIcon' />
                </Button>
              </>
            )}
          </Typography>
        </Box>
      ) : ''} 
      {isBookingPage ? <WhyBookWithUs /> : null}
    </div>
  );
};

export default PriceSummaryComponent;
